export function stopPropagation(
  event: React.MouseEvent | React.KeyboardEvent | React.TouchEvent
): void {
  event.stopPropagation();
  event.preventDefault();
}
